
    import {
      getAllPages,
      createPage,
      createAllPages,
      updatePage,
      deletePage
    } from "@/services/page";

    const state = {
      pages: [],
      processed: false
    };

    const getters = {
      getPages(state) {
        return state.pages;
      },
      pageProcessed(state){
        return state.processed;
      }
    };

    const actions = {
      fetchPages({ commit }, params) {
          commit("SET_PROCESSING");
          return new Promise((resolve, reject) => {
            getAllPages(
              params
            )
              .then(response => {
                commit("SET_PAGES", response.data);
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        createPage({ commit }, page) {
          return new Promise((resolve, reject) => {
            createPage(page)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        createAllPages({ commit }, pages) {
          return new Promise((resolve, reject) => {
            createAllPages(pages)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        updatePage({ commit }, page) {
          return new Promise((resolve, reject) => {
            updatePage(page)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        deletePage({ commit }, id) {
          return new Promise((resolve, reject) => {
            deletePage(id)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        }
      };

    const mutations = {
      SET_PAGES(state, data) {
        state.pages = data;
        state.processed = true;
      },
      SET_PROCESSING(state) {
        state.processed = false;
      },
      SET_PROCESSED(state) {
        state.processed = true;
      }
    };

    export default {
      state,
      getters,
      actions,
      mutations
    };
    